import { auth } from '../firebase';

export const saveMessage = async (conversationId, message, role) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('Non authentifié');
  }

  try {
    const token = await currentUser.getIdToken();

    const response = await fetch('https://savemessage-5zm2gcbnlq-uc.a.run.app', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        data: { conversationId, message, role },
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Erreur serveur');
    }

    const result = await response.json();
    return result.result;
  } catch (error) {
    console.error('❌ Erreur:', error);
    throw error;
  }
};

export const getMessages = async (conversationId = null) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('Non authentifié');
  }

  try {
    const token = await currentUser.getIdToken();

    const response = await fetch('https://getmessages-5zm2gcbnlq-uc.a.run.app', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        data: { conversationId },
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Erreur serveur');
    }

    const result = await response.json();
    return result.result.messages;
  } catch (error) {
    console.error('❌ Erreur:', error);
    throw error;
  }
};
